import BeforeContinue from './BeforeContinue';

export default BeforeContinue;
